import React from 'react';
import styled from 'styled-components';
import { StyledButton } from '../../../Components/Generics.styled';
import propTypes from 'prop-types';

const OrderSummaryContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const OrderSummary = ({ history }) => {
    return (
        <OrderSummaryContainer>
            <div style={{ fontSize: '44px', fontWeight: 'bold' }}>Thank you.</div>
            <div style={{ fontSize: '34px' }}> Your order is being proccessed.</div>
            <br />
            <StyledButton onClick={() => history.push('/portal/adServices/viewAdServices')}>View Ad Services</StyledButton>
        </OrderSummaryContainer>
    );
};

OrderSummary.propTypes = {
    history: propTypes.shape({
        push: propTypes.func,
    }),
};

export default OrderSummary;
